<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">페럼클럽</h3>
        <!-- <span>
          태초의 자연,
          <br />본질적인 자신과 조우하는
          <br />기쁨이 있는곳,
          <br />여기는 페럼클럽 입니다.
        </span>-->
      </div>
      <div class="txt">
        <h4 class="fs-50 fMTP-EB main_color pdb30">FERRUM CLUB</h4>
        <p class="lh30">
          태초의 자연, 본질적인 자신과 조우하는 기쁨이 있는곳, 여기는
          페럼클럽입니다.
        </p>
        <div class="pdt50 sub_slider">
          <ul>
            <li>
              <ol>
                <li v-if="viewCnt == 0">
                  <img
                    :src="require('./../../assets/img/sub/02/0201_01.jpg')"
                  />
                </li>
                <li v-if="viewCnt == 1">
                  <img
                    :src="require('./../../assets/img/sub/02/0201_02.jpg')"
                  />
                </li>
                <li v-if="viewCnt == 2">
                  <img
                    :src="require('./../../assets/img/sub/02/0201_03.jpg')"
                  />
                </li>
                <li v-if="viewCnt == 3">
                  <img
                    :src="require('./../../assets/img/sub/02/0201_04.jpg')"
                  />
                </li>
                <li v-if="viewCnt == 4">
                  <img
                    :src="require('./../../assets/img/sub/02/0201_05.jpg')"
                  />
                </li>
              </ol>
            </li>
            <li>
              <a class="tap" :class="{ on: viewCnt == 0 }" @click="viewCnt = 0">
                <img :src="require('./../../assets/img/sub/02/0201_01.jpg')" />
              </a>
              <a class="tap" :class="{ on: viewCnt == 1 }" @click="viewCnt = 1">
                <img :src="require('./../../assets/img/sub/02/0201_02.jpg')" />
              </a>
              <a class="tap" :class="{ on: viewCnt == 2 }" @click="viewCnt = 2">
                <img :src="require('./../../assets/img/sub/02/0201_03.jpg')" />
              </a>
              <a class="tap" :class="{ on: viewCnt == 3 }" @click="viewCnt = 3">
                <img :src="require('./../../assets/img/sub/02/0201_04.jpg')" />
              </a>
              <a class="tap" :class="{ on: viewCnt == 4 }" @click="viewCnt = 4">
                <img :src="require('./../../assets/img/sub/02/0201_05.jpg')" />
              </a>
              <div class="bnt_area">
                <a @click="btnPrev">
                  <img :src="require('./../../assets/img/sub/next.png')" />
                </a>
                <a @click="btnNext">
                  <img
                    :src="require('./../../assets/img/sub/next.png')"
                    style="transform: rotate(180deg);"
                  />
                </a>
                <a @click="btnPlay">
                  <img
                    v-if="!timerId"
                    :src="require('./../../assets/img/sub/play.png')"
                  />
                  <img
                    v-if="timerId"
                    :src="require('./../../assets/img/sub/stop.png')"
                    style
                  />
                </a>
              </div>
            </li>
          </ul>
        </div>

        <p class="fNS-B pdb30 pdt50">Recover your Composure</p>
        <p class="lh30 pdb10">
          여유의 미학이 있는곳, 페럼클럽(Ferrum Club)은 유려한 산세와 고요한 숲
          맑은 계곡을 그대로 포용하며
          <br />기품 있는 자연의 모습을 가지고 있습니다.
        </p>

        <p class="fNS-B pdt50">
          신시아다이(Cynthia Dye) & 안도 다다오(Ando Tadao)
        </p>
        <p class="lh30 pdt30">
          선과 면의 직선과 곡선의 신비로움을 건축물에 활용하는 세계 4대 건축가인
          안도타다오가 생애 최초로 디자인한 클럽하우 스는 플레이 후 지친
          골퍼들에게 자연을 벗삼을 휴식의 기쁨을 선사합니다.
        </p>
        <div class="pdt40 pdb20">
          <a href="https://www.ferrumclub.com/" target="_blank">
            <button class="btn_link">페럼클럽 바로가기</button>
          </a>
        </div>
        <p class="pdt50">주소 : (469-873) 경기도 여주시 점동면 점동로 181</p>
        <p class="pdt10">Tel : 031-887-7000</p>
        <p class="pdt10">FAX: 031-887-7070</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "Ferrumclub.vue",
    viewCnt: 0,
    timerId: undefined
  }),
  methods: {
    btnNext() {
      console.log("btnNext");
      this.viewCnt = this.viewCnt + 1;

      if (this.viewCnt > 4) {
        this.viewCnt = 0;
      }

      console.log("this.viewCnt = " + this.viewCnt);
    },
    btnPrev() {
      console.log("btnPrev");
      this.viewCnt = this.viewCnt - 1;
      if (this.viewCnt < 0) {
        this.viewCnt = 4;
      }
      console.log("this.viewCnt = " + this.viewCnt);
    },
    btnPlay() {
      if (this.timerId) {
        console.log("phase");
        clearInterval(this.timerId);
        this.timerId = undefined;
      } else {
        console.log("play");
        this.timerId = setInterval(() => {
          this.btnNext();
        }, 3000);
      }
    }
  },
  computed: {},
  destroyed() {
    if (this.timerId) {
      console.log("phase");
      clearInterval(this.timerId);
      this.timerId = undefined;
    }
  },
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub02/Ferrumclub.vue